export default __webpack_public_path__ + "static/media/opportunity.58b1ee2f.svg";